The scheme ID of the event.

Currently, only the `seekAnz` and `seekAnzPublicTest` schemes emit `HirerRelationshipChanged` events.
